export default __webpack_public_path__ + "static/media/12-21.15ab1001.jpeg";